module.exports = __webpack_public_path__ + "img/book1.6b860b5c.png";